import React from 'react';

import styles from './empty-drawer.placeholder.module.scss';

interface EmptyDrawerPlaceholderProps {
  text: string | React.ReactNode;
  icon: React.ReactNode;
}

export const EmptyDrawerPlaceholder: React.FC<EmptyDrawerPlaceholderProps> = ({ icon, text }) => (
  <div className={styles['container']}>
    {icon}

    {typeof text === 'string' ? <p className={styles['text']}>{text}</p> : text}
  </div>
);
